import http from 'plugins/axios'

export default {
  mockList(data) {
    return http.get({
      url: '/la/admin/mock/wallet/mock/list',
      data,
    })
  },

  mockDeposit(data) {
    return http.post({
      url: '/la/admin/mock/wallet/mock/deposit',
      data,
      dataType: 'form',
    })
  },

  mockWithdraw(data) {
    return http.post({
      url: '/la/admin/mock/wallet/mock/withdraw',
      data,
      dataType: 'form',
    })
  },
  mockRebate(data) {
    return http.post({
      url: '/la/admin/rebate/mockRebate',
      data,
      dataType: 'form',
    })
  },
}
